import React from "react";
import { MPSharedTable, MPSharedHeader } from "../Shared";
import { useSearchQuery, usePagination } from "../../../hooks";
import { useGetEventTypesQuery } from "../services";
import { getLocalizedString } from "../../../shared/translation";

export const EventTypesContainer = () => {
  const { page, setPage, perPage, pagination } = usePagination();

  const { setSimpleSearch, simpleSearch } = useSearchQuery({
    page,
    setPage,
  });

  const queryParams = {
    page: page,
    per_page: perPage,
    order_by: "created_at",
    order_dir: "desc",
  };

  const {
    data = {
      total_count: 0,
      data: [],
    },
    error,
    isFetching,
    isSuccess,
  } = useGetEventTypesQuery({
    ...queryParams,
    q: JSON.stringify({ name_cont: simpleSearch }),
  });

  const headers = [
    {
      label: getLocalizedString("name", "Name"),
      key: "name",
      className: "name",
    },
    {
      label: getLocalizedString("classification", "Classification"),
      key: "classification",
      className: "type",
    },
    {
      label: getLocalizedString("added_on", "Added On"),
      key: "created_at",
      className: "date",
    },
  ];

  return (
    <article className="main-container">
      <MPSharedHeader
        groupName="configurations"
        resourceName="Event Types"
        heading={getLocalizedString("configurations", "Configurations")}
        handleSearchKey={setSimpleSearch}
        simpleSearchPlaceholder={getLocalizedString("search_by_name", "Search by Name")}
      />

      <MPSharedTable
        resourceName="Event Types"
        data={data?.data || []}
        error={error}
        isLoading={isFetching}
        isSuccess={isSuccess}
        headers={headers}
        pagination={{ ...pagination, count: data.total_count }}
        skipClientId
        className="event-type"
      />
    </article>
  );
};
